import { createFileRoute } from '@tanstack/react-router';
import { useAuth } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useInitialRoute } from '~/hooks/useInitialRoute';

export const Route = createFileRoute('/')({
  component: IndexComponent,
});

function IndexComponent() {
  const auth = useAuth();
  const navigate = useNavigate();

  // Handle initial route navigation
  useInitialRoute();

  // Redirect to sign-in if not authenticated
  useEffect(() => {
    if (auth.isLoaded && !auth.isSignedIn) {
      navigate({ to: '/sign-in' });
    }
  }, [auth.isLoaded, auth.isSignedIn, navigate]);

  // Show loading while processing or redirecting
  if (!auth.isLoaded || !auth.isSignedIn) {
    return (
      <div
        className="flex align-items-center justify-content-center"
        style={{ height: '100vh' }}
      >
        <div className="text-center">
          <h2>Loading...</h2>
          <p>Setting up your application...</p>
        </div>
      </div>
    );
  }

  // This should never render as we redirect in the effect
  return null;
}
